// DS: i6.16
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const AddVideo: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 3c.552 0 1 .403 1 .9v16.2c0 .497-.448.9-1 .9H3c-.552 0-1-.403-1-.9V3.9c0-.497.448-.9 1-.9h18zm-1 2H4v14h16V5zM10 7.748a1 1 0 01.507.138l5.528 3.252a1 1 0 010 1.724l-5.528 3.252A1 1 0 019 15.25V8.75a1 1 0 011-1z"
          fillRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};
AddVideo.displayName = 'AddVideo';

export default AddVideo;
